import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../../services/bm.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../services/user.service';
import { HttpClient } from '@angular/common/http';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange,
  MenuCallbackArgs
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../../services/utility.service';
import { AdminApiService } from '../../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, bmdashboardFilterValue, year, kpi, kpiInbox, slaIssueList } from '../../../../models/slakpi';
import { division, department, performancemaster } from '../../../../models/admin';
import { SLAKPIApiService } from '../../../../services/slakpi.service';
import { KPIInfoComponent } from '../../kpi-info/kpi-info.component';

declare var google: any;
@Component({
  selector: 'app-slakpi-view',
  templateUrl: './slakpi-view.component.html',
  styleUrls: ['./slakpi-view.component.css']
})
export class SLAKPIViewComponent implements OnInit {

  
  public gridApi;
  public gridColumnApi;

  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;

  public rowData: [];
  public businessDivisionUno: any;
  public businessDeptUno: any;
  public trendUno: any;
  public yearUno: any=0;
  public division_data: any;
  public department_data: any;
  public trend_data: any;
  public yearData: any;

  public count_data: any;
  public position_data: any=[];
  public peer_data: any=[];
  public bmPeer_data: any=[];
  public map_data: any=[];

  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  kpiUno: any;
  kpiTrnUno: any;
  noDataImg: any;
  tenantUno: any;
    peerFilter_Data: any=[];
    peerUno: any='';
  kpiData: any = {};
  KPIPerformanceTrend_data: any= [];
    chartOption: { };
  kpiView_data: any = [];
    actualValueText: any;
    targetValueText: any;
  bandColor: string;
  sourcePage: string;
    slaIssuelist_data: any;
    
   
    modalRef: BsModalRef;
    dataset: any=[];
    dataSearch: any[];
  searchText: string;
  slakpiPerformanceFilter: any = {};

  public historyStartIndex: number = 1;
  public historyMaxCount: number = 100;
  historydisableMore: boolean = true;
  public issueComment_data_hostory: any = [];
  datasetComments: any;
  gridOptionsHistory: GridOption;
  columnCommentDefinitions: Column[];
  cmtsGrid: AngularGridInstance;
  @ViewChild('IssueDialog', { static: false }) IssueDialog: TemplateRef<any>;
  @ViewChild('IssueCommentDialog', { static: false }) IssueCommentDialog: TemplateRef<any>;
  kpinameSelected: any;
  public kpiUnoSelected: number = 0;
  //public kpinameSelected: string = '';
  @ViewChild('KPIAllHistoryDialog', { static: false }) KPIAllHistoryDialog: TemplateRef<any>;
  chartType_data: any;
  public chartValue: string = 'quarter';
    selectedJustification: any;

  constructor(public restApi: BMApiService, public restSLAKPIApi: SLAKPIApiService, public restAdminApi: AdminApiService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, public _activatedRoute: ActivatedRoute, private kpiAllHistoryComponent: KPIInfoComponent) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.slakpiPerformanceFilter = this.userService.getSLAKPIFilterInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin') ? true : false;
    if (!this.isAdmin) {
      //this.CheckUserPermission();
    } else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      //this.yearUno = Number(this.user.currentYear);

    }

    this.getChartTypeData();
  }
  
  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      enableCheckboxSelector: false,

      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },

    };

    this.gridOptionsHistory = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,

      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'myTabContent',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    

    this._activatedRoute.params.subscribe((params: Params) => {
      
      if (params['kpiuno'] != null) {
        this.kpiTrnUno = Number(params['kpiuno']);
        this.loadKPICodeDetails(this.kpiTrnUno);
      }
    });
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      
      this.kpiUno = Number(params['kpinumber']);
      this.actualValueText = (params['actual']);
      this.targetValueText = (params['target']);
      this.bandColor = (params['band']);
      this.sourcePage = (params['sourcePage']);
      //this.loadKPI();
      
      this.loadSlaIssueList(3);
    });

    

    let strBandColor = this.bandColor;
            if (strBandColor == 'Red')
              this.bandColor = `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
          if (strBandColor == 'Orange')
            this.bandColor = `<div class="bg-grey-progress" > <span class="orange-bar"></span></div>`;
          if (strBandColor == 'Yellow')
            this.bandColor = `<div class="bg-grey-progress" > <span class="yellow-bar"></span></div>`;
          if (strBandColor == 'Light Green')
            this.bandColor = `<div class="bg-grey-progress" > <span class="light-green-bar"></span></div>`;
          if (strBandColor == 'Green')
      this.bandColor = `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;
    if (strBandColor == 'Blue')
      this.bandColor = `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;


  }
  

 
onClickReturn()
{ return false;}


  backtoInbox() {
    if (this.sourcePage == 'sla')
      this.router.navigateByUrl('/dashboard-slaperformance');
      else
    this.router.navigateByUrl('/dashboard-slakpi');
  }

  //loadKPIInbox() {
  //  
  //  this.spinner.show();
  //  let inpValue = new kpiInbox();
  //  inpValue.languageUno = 1033;
  //  inpValue.itemUno = 0;
  //  inpValue.condition = 2;
  //  inpValue.tenantUno = this.tenantUno;
  //  inpValue.userUno = this.login_UserID;
  //  //inpValue.slaUno = this.slaUno;
  //  //inpValue.slaRuleUno = this.frequencyUno;
  //  //inpValue.reportingDivisionUno = this.divisionUno;

  //  inpValue.slaUno = 0;
  //  inpValue.currentYear = 0;
  //  inpValue.currentQuarter = 0;
  //  inpValue.reportingDivisionUno = 0;
  //  inpValue.slaRuleUno = 0;

  //  //inpValue.currentYear = this.currentYear;
  //  //inpValue.currentQuarter = this.currentQuarter;
  //  inpValue.currentMonth = 0;
  //  inpValue.currentHalf = 0;
  //  inpValue.filterDataCollection = 0;
  //  inpValue.filterOverdue = 0;
  //  inpValue.filterApproval = 0;
  //  inpValue.filterCompleted = 0;
  //  inpValue.filterColor = '';
  //  inpValue.isAdmin = this.isAdmin;

  //  this.restSLAKPIApi.getKpiInbox(inpValue)
  //    .subscribe(data => {
  //      

  //      let kpiInbox_data: any = [];
  //      let rtnData: any = data;
  //      kpiInbox_data = rtnData.data;
  //      this.spinner.show();
  //      if (kpiInbox_data != null && kpiInbox_data.length > 0)
  //        this.kpiView_data = kpiInbox_data.filter(x => x.kpiTrnUno == this.kpiTrnUno);

  //      if (this.kpiView_data.length > 0) {
  //        this.kpiUno = this.kpiView_data[0].kpiUno;
  //        this.loadKPI();
  //        this.viewKPIChart(this.kpiUno);


  //        //Actual
  //        let actualValue = '';
  //        let kpidata = this.kpiView_data[0];
  //        if (strBandColor != '' && kpidata.dataOwnerActionBy != '' && kpidata.slaRuleUno != 4)
  //          //actualValue = kpidata.targetValue + '%';
  //          actualValue = kpidata.targetValue;
  //        if ((strBandColor != '' && kpidata.dataOwnerActionBy != '' && kpidata.slaRuleUno == 4))
  //          actualValue = strBandColor == 'Green' ? 'Pass' : 'Fail';
  //        if (strBandColor == '' && kpidata.dataOwnerActionBy != '' && kpidata.dataOwnerActionBy != null && (kpidata.isNANRNT != null && kpidata.isNANRNT != ''))
  //          actualValue = kpidata.isNANRNT;
  //        if ((kpidata.dataOwnerExists == 1 || this.isAdmin) && strBandColor == '' && kpidata.dataOwnerActionBy == '' && (kpidata.isNANRNT == '' || kpidata.isNANRNT == null)) {
  //          actualValue = '-'
  //        }
  //        if (strBandColor == '' && kpidata.dataOwnerActionBy != '' && kpidata.isNANRNT != '')
  //          actualValue =  kpidata.isNANRNT ;

  //        this.actualValueText = actualValue;
  //        this.targetValueText = kpidata.actualValueText;
  //        //if (kpidata.actualValueText == 'Pass' || kpidata.actualValueText == 'Fail') {
  //        //  this.targetValueText = kpidata.actualValueText;
  //        //} else {
  //        //  this.targetValueText = kpidata.actualValueText + '%';
  //        //}


  //        //Band
  //        let band = '';
  //        if (kpidata.slaRuleUno != 1 && kpidata.slaRuleUno != 2 && strBandColor == '' && (kpidata.isNANRNT != null && kpidata.isNANRNT != ''))
  //          band = `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
  //        if (strBandColor == '' && (kpidata.slaRuleUno == 1 || kpidata.slaRuleUno == 2) && (kpidata.isNANRNT == 'NA' || kpidata.isNANRNT == 'ND' || kpidata.isNANRNT == 'NR'))
  //          band = `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
  //        if (strBandColor == 'Red')
  //          band = `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
  //        if (strBandColor == 'Orange')
  //          band = `<div class="bg-grey-progress" > <span class="orange-bar"></span></div>`;
  //        if (strBandColor == 'Yellow')
  //          band = `<div class="bg-grey-progress" > <span class="yellow-bar"></span></div>`;
  //        if (strBandColor == 'Light Green')
  //          band = `<div class="bg-grey-progress" > <span class="light-green-bar"></span></div>`;
  //        if (strBandColor == 'Green')
  //          band= `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;

  //        this.bandColor = band;
  //      }

        

        
  //      //const mockDataset = [];
  //      //for (let i = 0; i < this.kpiInbox_data.length; i++) {
  //      //  mockDataset[i] = {
  //      //    id: i + 1,

  //      //    kpiCode: this.kpiInbox_data[i].kpiCode,
  //      //    kpiNameEn: this.kpiInbox_data[i].kpiNameEn,
  //      //    slaName: this.kpiInbox_data[i].slaName,
  //      //    periodDisplay: this.kpiInbox_data[i].periodDisplay,
  //      //    slaRuleName: this.kpiInbox_data[i].slaRuleName,
  //      //    targetValueText: this.kpiInbox_data[i].targetValueText,
  //      //    slaRuleUno: this.kpiInbox_data[i].slaRuleUno,
  //      //    dataOwnerActionBy: this.kpiInbox_data[i].dataOwnerActionBy,
  //      //    targetValue: this.kpiInbox_data[i].targetValue,
  //      //    bandValueText: this.kpiInbox_data[i].bandValueText,
  //      //    bandValue: this.kpiInbox_data[i].bandValue,
  //      //    bandColour: this.kpiInbox_data[i].bandColour,
  //      //    kpiUno: this.kpiInbox_data[i].kpiUno,
  //      //    isNANRNT: this.kpiInbox_data[i].isNANRNT,
  //      //    dataOwnerExists: this.kpiInbox_data[i].dataOwnerExists,
  //      //    actualValueText: this.kpiInbox_data[i].actualValueText,
  //      //    actualTargetValue: this.kpiInbox_data[i].actualTargetValue,
  //      //    currentStage: this.kpiInbox_data[i].currentStage,
  //      //    kpiTrnUno: this.kpiInbox_data[i].kpiTrnUno,
  //      //    approver1Exists: this.kpiInbox_data[i].approver1Exists,
  //      //    approver2Exists: this.kpiInbox_data[i].approver2Exists,
  //      //    approver3Exists: this.kpiInbox_data[i].approver3Exists,
  //      //    commentCount: this.kpiInbox_data[i].commentCount,
  //      //    dataOwnerActionByUno: this.kpiInbox_data[i].dataOwnerActionByUno,
  //      //    level1ApprovedBy: this.kpiInbox_data[i].level1ApprovedBy,
  //      //    level2ApprovedBy: this.kpiInbox_data[i].level2ApprovedBy,
  //      //    level3ApprovedBy: this.kpiInbox_data[i].level3ApprovedBy,
  //      //    level1Approved: this.kpiInbox_data[i].level1Approved,
  //      //    level2Approved: this.kpiInbox_data[i].level2Approved,
  //      //    level3Approved: this.kpiInbox_data[i].level3Approved,
  //      //    level1ApproverUno: this.kpiInbox_data[i].level1ApproverUno,
  //      //    level2ApproverUno: this.kpiInbox_data[i].level2ApproverUno,
  //      //    level3ApproverUno: this.kpiInbox_data[i].level3ApproverUno,
  //      //    dataOwnerUno: this.kpiInbox_data[i].dataOwnerUno,
  //      //    kpiYearName: this.kpiInbox_data[i].kpiYearName,
  //      //    kpiQuarterName: this.kpiInbox_data[i].kpiQuarterName,
  //      //    scheduleText: this.kpiInbox_data[i].scheduleText,
  //      //    scheduleUno: this.kpiInbox_data[i].scheduleUno,
  //      //    statusUno: this.kpiInbox_data[i].statusUno,
  //      //  };
  //      //}
       
  //      setTimeout(() => { this.spinner.hide(); }, 1500);
  //      //setTimeout(() => { this.groupOptions = { columns: ['kpiNameEn'] }; }, 100);
  //    },
  //      (error) => {
  //        //Called when error
  //        this.spinner.hide();
         
  //      }
  //    ).add(() => {
  //      //Called when operation is complete (both success and error)
  //      //  this.spinner.hide();
  //      //this.isStart = false;
  //    });
  //}

  loadKPICodeDetails(kpiTrnUno: number) {


    this.spinner.show();
    let inpValue = new kpiInbox();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restSLAKPIApi.getKpiCodeDetails(inpValue)
      .subscribe(data => {
        
        //this.data = data;
        if (data != null && data != undefined) {
          //this.kpiCodeDetail = new kpiInbox();
          this.kpiData = data[0];

          this.chartValue = (this.kpiData.schedule == 'Yearly') ? 'year' : 'quarter';
          this.viewKPIChart(this.kpiUno);
        }
       
        this.spinner.hide();
        
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  loadKPI() {
    this.spinner.show();
    
    let inpValue = new kpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = this.kpiUno;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.frequencyUno = 0;
    inpValue.slaRuleUno =  0;
    inpValue.businessDivisionUno =  0;
    inpValue.reportingDivisionUno =  0;

    this.restSLAKPIApi.getKPIs(inpValue)
      .subscribe(data => {
        
        
        this.kpiData = data[0];
        
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  viewKPIChart(kpiUno: any) {


    //Get The Chart Value

    this.spinner.show();
    let inpValue = new kpiInbox();
    inpValue.kpiUno = kpiUno;
    inpValue.kpiYear = this.user.currentYear;
    inpValue.kpiQuarter = 0;
    inpValue.scheduleText = this.chartValue;
    inpValue.userUno = this.login_UserID;
    this.restSLAKPIApi.getKpiYearWiseChart(inpValue)
      .subscribe(data => {
        this.KPIPerformanceTrend_data = data;


        setTimeout(() => {

          //google.charts.load('current', { 'packages': ['bar'] });
         // google.charts.setOnLoadCallback(this.kpipertrend(this.KPIPerformanceTrend_data));
          this.kpipertrend(this.KPIPerformanceTrend_data);
        }, 1000);
        this.spinner.hide();



        // let chartComponent1: any = getInstance('#chart-container', Chart);
        // chartComponent1.refresh();



      },
        (error) => {
          //Called when error
          this.spinner.hide();

        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        // this.spinner.hide();

      });



  }

  kpipertrend = (option_data: any) => {
    

    let tempArray_XAxis = [];
    let tempArray_Target = [];
    let tempArray_Actual = [];
    //let sumofActualValue = 0;
    //let sumofTargetValue = 0;
    for (var i = 0; i < option_data.length; i++) {
      let kpiYearName = option_data[i].kpiYearName;
      let actualTargetValue = (option_data[i].actualTargetValue != null ) ? option_data[i].actualTargetValue : 0;
      let targetValue = (option_data[i].targetValue != null ) ? option_data[i].targetValue : 0;
      //sumofActualValue += actualTargetValue;
      //sumofTargetValue += targetValue;

      tempArray_XAxis.push(kpiYearName);
      tempArray_Actual.push(actualTargetValue);
      tempArray_Target.push(targetValue);
      
      // tempArray.push([option_data[i].kpiYearName, parseInt(option_data[i].actualTargetValue), parseInt(option_data[i].targetValue)]);
    }
    //if (sumofActualValue > 0 && sumofTargetValue > 0) {

    //  tempArray_XAxis.push('YTD');
    //  tempArray_Actual.push(sumofActualValue);
    //  tempArray_Target.push(sumofTargetValue);

    //}
    //this.chartOption = {
    //  tooltip: {
    //    trigger: 'axis'
    //  },
    //  legend: {
    //    data: ['DEWA Actual', 'DEWA Target']
    //  },
    //  toolbox: {
    //    show: true,
    //    feature: {
    //      dataView: { show: true, readOnly: false },
    //      magicType: { show: true, type: ['line', 'bar'] },
    //      restore: { show: true },
    //      saveAsImage: { show: true }
    //    }
    //  },
    //  calculable: true,
    //  xAxis: [
    //    {
    //      type: 'category',
    //      data: tempArray_XAxis
    //    }
    //  ],
    //  yAxis: [
    //    {
    //      type: 'value'
    //    }
    //  ],
    //  series: [
    //    {
    //      name: 'Actual',
    //      type: 'bar',
    //      data: tempArray_Actual,

    //    },
    //    {
    //      name: 'Target',
    //      type: 'bar',
    //      data: tempArray_Target,

    //    }
        
    //  ]
    //};
    this.chartOption = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['DEWA Actual', 'DEWA Target']
      },
      color: ['#68b097', '#9e9e9e'],
      toolbox: {
        show: true,
        feature: {
          //dataView: { show: true, readOnly: false },
          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: tempArray_XAxis
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      grid: {
        left: '0',
        top: '10%',
        right: '0',
        bottom: '10%',
        containLabel: true
      },
      dataZoom: [
        {
          show: true,
          start: 1,
          end: 100,
          right: '2%',
          left: '5%',
          top: '85%',
          fillerColor: 'rgba(255, 255, 255, 0)',
          borderColor: '#fff',
          //backgroundColor: 'rgba(255, 255, 255, 1)',
          dataBackground: {
            areaStyle: {
              color: 'rgba(255, 255, 255, 1)',
            }
          },
          showDataShadow: false,
          showDetail: false,
          //zoomSelectionColor: '#fff',
          moveHandleSize: 1.
        },


      ],
      series: [

        {
          name: 'DEWA Actual',
          type: 'bar',
          data: tempArray_Actual,
          barWidth: "10%",

        },
        {
          name: 'DEWA Target',
          type: 'bar',
          data: tempArray_Target,
          barWidth: "10%",

        }
      ]
    };

  }


  loadSlaIssueList(condition) {
    

    let slaUno = 0;
    let yearUno = 0;
    let quarterUno = 0;
    let divisionUno = 0;
    let frequencyUno = 0;
    if (this.slakpiPerformanceFilter != undefined) {
       slaUno = parseInt(this.slakpiPerformanceFilter.slaUno);
       yearUno = parseInt(this.slakpiPerformanceFilter.yearUno);
       quarterUno = parseInt(this.slakpiPerformanceFilter.quarterUno);
       divisionUno = parseInt(this.slakpiPerformanceFilter.divisionUno);
       frequencyUno = parseInt(this.slakpiPerformanceFilter.frequencyUno);

    }

    this.spinner.show();
    let inpValue = new slaIssueList();
    inpValue.languageUno = 1033;
    inpValue.itemUno = this.kpiTrnUno;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = slaUno;
    inpValue.kpiyear = yearUno;
    inpValue.kpiquarter = quarterUno;
    inpValue.divisionUno = divisionUno;
    inpValue.frequencyUno =frequencyUno;
    inpValue.half = 0;
    inpValue.month = 0;
    this.restSLAKPIApi.getSlaIssueList(inpValue)
      .subscribe(data => {
        
        this.slaIssuelist_data = data;
        const mockDataset = [];
        for (let i = 0; i < this.slaIssuelist_data.length; i++) {
         
          //if (this.slaIssuelist_data[i].kpiUno == this.kpiUno) {
            mockDataset[i] = {
              id: i+1,//1
              kpiCode: this.slaIssuelist_data[i].kpiCode,
              kpiName: this.slaIssuelist_data[i].kpiName,
              periodDisplay: this.slaIssuelist_data[i].periodDisplay,
              issueDescription: this.slaIssuelist_data[i].issueDescription,
              issueStatus: this.slaIssuelist_data[i].issueStatus,
              kpiUno: this.slaIssuelist_data[i].kpiUno,
              kpiTrnIssueUno: this.slaIssuelist_data[i].kpiTrnIssueUno,
              bandColour: this.slaIssuelist_data[i].bandValue,
              kpiTrnUno: this.slaIssuelist_data[i].kpiTrnUno,
            };
         // }
        }
        this.dataset = mockDataset;//mockDataset.filter(x => x.kpiUno == this.kpiUno);
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiName', name: 'KPI', field: 'kpiName', sortable: true, width: 250,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'periodDisplay', name: 'Period', field: 'periodDisplay', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'periodDisplay', 'periodDisplay'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'issueDescription', name: 'Issue Description', field: 'issueDescription', sortable: true, type: FieldType.string, filterable: true, width: 250,
        filter: {
          collection: this.uniqueArray(this.dataset, 'issueDescription', 'issueDescription'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'bandColour', name: 'Performance', field: 'bandColour', sortable: true, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bandColour', 'bandColour'),
          model: Filters.multipleSelect,
        },

      },
      {
        id: 'issueStatus', name: 'Status', field: 'issueStatus', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'issueStatus', 'issueStatus'),
          model: Filters.multipleSelect,
        },

      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            //{
            //  command: 'Resolve-row', titleKey: 'Resolve_ROW', positionOrder: 60, title: 'Resolve Issue',
            //  itemVisibilityOverride: (args: MenuCallbackArgs) => {
            //    let data = args.dataContext;
            //    if ((data.issueStatus != 'Resolved' && data.issueStatus != 'Closed' && data.issueStatus != 'Cancelled' && this.permision_resolve))
            //      return true;
            //    else false;
            //  },
            //  iconCssClass: 'fa fa-circle-o-notch fa-lg ', cssClass: 'blue', textCssClass: 'bold',
            //  action: (e, args) => {
            //    let data = args.dataContext;
            //    this.showIssueDialog(data, data.issueDescription, 'updatestatus')
            //  }
            //},


            //{
            //  command: 'Update-row', titleKey: 'Update_ROW', positionOrder: 61, title: 'Issue Update',
            //  iconCssClass: 'fa fa-edit fa-lg ', cssClass: 'blue', textCssClass: 'bold',
            //  itemVisibilityOverride: (args: MenuCallbackArgs) => {
            //    let data = args.dataContext;
            //    if (data.issueStatus != 'Resolved' && data.issueStatus != 'Closed' && data.issueStatus != 'Cancelled' && this.permision_issueUpdate)
            //      return true;
            //    else false;
            //  },
            //  action: (e, args) => {
            //    let data = args.dataContext;
            //    //this.showIssueDialog(data, data.issueDescription, 'updatedescription')
            //  }
            //},

            {
              command: 'Log-row', titleKey: 'Log_ROW', positionOrder: 64, title: 'Issue Log',
              iconCssClass: 'fa fa-history fa-lg orange-text  Blink ', textCssClass: 'bold',

              action: (e, args) => {
                let data = args.dataContext;
                this.showIssueCommentDialog(data)
              },
            },


            {
              command: 'Info-row', titleKey: 'Info_ROW', positionOrder: 65, title: 'KPI Info',
              iconCssClass: 'fa fa-info-circle fa-lg ', cssClass: 'red', textCssClass: 'bold',

              action: (e, args) => {
                let data = args.dataContext;
                this.viewKPIHistoryAll(data.kpiUno, data.kpiName);
              }
            },


          ],
        }
      }
    ]


  }

  actualFormatter: Formatter = (row, cell, value, columnDef, data) => {

    if (data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno != 4)
      return data.targetValue;
    if ((data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno == 4))
      return data.bandColour == 'Green' ? 'Pass' : 'Fail';
    if (data.bandColour == '' && data.dataOwnerActionBy != '' && data.dataOwnerActionBy != null && (data.isNANRNT != null && data.isNANRNT != ''))
      return data.isNANRNT;
    if ((data.dataOwnerExists == 1 || this.isAdmin) && data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null)) {
      return '<a matTooltipClass="my-custom-tooltip-avg" title="Data Entry"  class="bcopy-btn" style="cursor:pointer !important;">-</a>'
    }
    if (data.bandColour == '' && data.dataOwnerActionBy != '' && data.isNANRNT != '')
      return '<a  style="text-decoration:underline; cursor:pointer;" >' + data.isNANRNT + '</a>';



  };

  bandFormatter: Formatter = (row, cell, value, columnDef, data) => {
    
    //if (data.slaRuleUno != 1 && data.slaRuleUno != 2 && data.bandColour == '' && (data.isNANRNT != null && data.isNANRNT != ''))
    //  return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
    //if (data.bandColour == '' && (data.slaRuleUno == 1 || data.slaRuleUno == 2) && (data.isNANRNT == 'NA' || data.isNANRNT == 'ND' || data.isNANRNT == 'NR'))
    //  return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
    if (data.bandColour == 'Red')
      return `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
    if (data.bandColour == 'Orange')
      return `<div class="bg-grey-progress" > <span class="orange-bar"></span></div>`;
    if (data.bandColour == 'Yellow')
      return `<div class="bg-grey-progress" > <span class="yellow-bar"></span></div>`;
    if (data.bandColour == 'Light Green')
      return `<div class="bg-grey-progress" > <span class="light-green-bar"></span></div>`;
    if (data.bandColour == 'Green')
      return `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;

  };

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    // angularGrid
    this.userService.angularGrid = angularGrid;
  }
  
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }
  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiName && a.kpiName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.periodDisplay && a.periodDisplay.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.issueDescription && a.issueDescription.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.bandValueText && a.bandValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.issueStatus && a.issueStatus.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }


  showIssueCommentDialog(data: any) {

    this.modalRef = this.modalService.show(
      this.IssueCommentDialog,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    //this.issueComment_data = [];
    this.kpinameSelected = data.kpiName;
    this.selectedJustification = data.issueDescription;
    this.loadIssueCommentHistory(data.kpiTrnIssueUno, true);
  }
  //Get KPI History
  loadIssueCommentHistory(kpiTrnIssueUno: number, isStart) {
    this.spinner.show();
    let inpValue = new slaIssueList();
    inpValue.kpiTrnIssueUno = kpiTrnIssueUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;;
    this.historyStartIndex = (this.historyStartIndex == undefined || this.historyStartIndex < 1 || isStart) ? 1 : this.historyStartIndex;
    inpValue.startIndex = this.historyStartIndex;
    inpValue.maxCount = this.historyMaxCount;

    this.restSLAKPIApi.getkpiIssueComment(inpValue)
      .subscribe(data => {
        
        let objData: any = data;

        if (this.historyStartIndex == 1) {
          this.issueComment_data_hostory = [];
          this.issueComment_data_hostory = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.issueComment_data_hostory.push(objData[i]);
          }
        }

        const mockDataset = [];
        for (let i = 0; i < this.issueComment_data_hostory.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            action: this.issueComment_data_hostory[i].action,
            postedBy: this.issueComment_data_hostory[i].postedBy,
            postedDate: this.issueComment_data_hostory[i].postedDate,
            comment: this.issueComment_data_hostory[i].comment,
          };
        }
        this.datasetComments = mockDataset;
        this.setCommentDefn();
        //if the result set is lessthen 10 then disable the load more icon
        this.historydisableMore = (objData.length >= 100) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.historyStartIndex = this.historyStartIndex + 1;
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  cmtsGridReady(angularGrid: AngularGridInstance) {
    this.cmtsGrid = angularGrid;
  }


  setCommentDefn() {
    this.columnCommentDefinitions = [
      { id: 'comment', name: 'Comment', field: 'comment', sortable: true },
      { id: 'postedBy', name: 'Created By', field: 'postedBy', sortable: true },
      { id: 'postedDate', name: 'Created Date', field: 'postedDate', sortable: true },


    ];
  }

  viewKPIHistoryAll(kpiUno: any, kpiNameEn: any) {
    this.kpiUnoSelected = kpiUno;
    this.kpinameSelected = kpiNameEn;
    this.kpiAllHistoryComponent.viewKPI(kpiUno);

    this.modalRef = this.modalService.show(
      this.KPIAllHistoryDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  getChartTypeData() {

    if (this.tenantUno == 2) {
      this.chartType_data = [
        { value: 'year', text: 'Year' },
        { value: 'quarter', text: 'Quarter' },
        { value: 'month', text: 'Month' }
      ];
    } else {
      this.chartType_data = [
        { value: 'year', text: 'Year' },
        { value: 'quarter', text: 'Quarter' }

      ];
    }
  }

  onchangeChart(e) {
    

    this.chartValue = (e && e.length > 0) ? e[0].value : 'quarter';


    this.viewKPIChart(this.kpiUno);

  }

  exportToExcelCmt() {
    var temp = this;
    setTimeout(function () {
      temp.cmtsGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }
}

